module.exports = __webpack_public_path__ + "static/img/kdylogo.d884711b.png";